var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isFinish)?_c('div',{staticClass:"loading",style:({background: _vm.bgcolor})},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }